import { LinkTypes } from '@theorchard/songwhip-events';

export const toLinkType = (link: string): LinkTypes => {
  const url = new URL(link);
  const isCustomDomain = !/songwhip\.com|localhost/.test(url.hostname);

  return isCustomDomain ? 'custom' : 'general';
};
